import { LegalEntityAuditGroupAuditsTabRow } from "../LegalEntityAuditGroupOverview.types.ts";

export enum LegalEntityAuditGroupAuditColumn {
    LegalEntity = "legalEntityName",
    UniqueIdentifier = "uniqueIdentifier",
    Type = "legalEntityTypes",
    Contact = "contact",
    AdditionalRecipients = "additionalRecipients",
    Assets = "assets",
    Classifications = "classifications",
    Status = "status",
    RiskLevel = "riskLevel",
    Score = "score",
    Evaluation = "evaluation",
    AuditReport = "auditReport",
    ReminderSent = "reminderSent",
    Note = "note",
}

export const allLegalEntityAuditGroupAuditColumns: Array<LegalEntityAuditGroupAuditColumn> = Object.values(LegalEntityAuditGroupAuditColumn);

// The row property the table sorts each column on. The list columns sort on their joined names, since sorting an
// array property compares nothing meaningful.
export const sortPropertyByColumn: Record<LegalEntityAuditGroupAuditColumn, keyof LegalEntityAuditGroupAuditsTabRow> = {
    [LegalEntityAuditGroupAuditColumn.LegalEntity]: "legalEntityName",
    [LegalEntityAuditGroupAuditColumn.UniqueIdentifier]: "uniqueIdentifier",
    [LegalEntityAuditGroupAuditColumn.Type]: "legalEntityTypeString",
    [LegalEntityAuditGroupAuditColumn.Contact]: "contact",
    [LegalEntityAuditGroupAuditColumn.AdditionalRecipients]: "additionalRecipientNames",
    [LegalEntityAuditGroupAuditColumn.Assets]: "assetsString",
    [LegalEntityAuditGroupAuditColumn.Classifications]: "classificationsString",
    [LegalEntityAuditGroupAuditColumn.Status]: "status",
    [LegalEntityAuditGroupAuditColumn.RiskLevel]: "riskLevel",
    [LegalEntityAuditGroupAuditColumn.Score]: "score",
    [LegalEntityAuditGroupAuditColumn.Evaluation]: "evaluation",
    [LegalEntityAuditGroupAuditColumn.AuditReport]: "report",
    [LegalEntityAuditGroupAuditColumn.ReminderSent]: "reminderSent",
    [LegalEntityAuditGroupAuditColumn.Note]: "notePlainText",
};

export const defaultOrderBy = "legalEntityName";
export const defaultOrder = "asc";

export const filterIds = {
    legalEntity: "legalEntity",
    type: "type",
    assets: "assets",
    classifications: "classifications",
    status: "status",
    riskLevel: "riskLevel",
    evaluations: "evaluations",
};
